import { EosAsset } from "@pro/common/eos";

export function formatDateTime(date: Date)
{
	return date.toLocaleDateString()
	       + " " + date.getHours().toString().padStart(2, '0')
	       + ":" + date.getMinutes().toString().padStart(2, '0');
}

export function formatTimeLeft(secondsLeft: number)
{
	const hours = Math.floor(secondsLeft / 3600);
	const minutes = Math.floor((secondsLeft - hours * 3600) / 60);
	const seconds = Math.floor(secondsLeft % 60);
	const formattedTime = hours.toString().padStart(2, "0") + ":" +
	                      minutes.toString().padStart(2, "0") + ":" +
	                      seconds.toString().padStart(2, "0");

	return formattedTime;
}

export function formatNumbers(value: number | string)
{
	if (typeof value === "number")
		value = value.toString();

	const parts = value.toString().split(".");
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
	return parts.join(".");
}

export function formatEosAsset(eosAsset: EosAsset)
{
	const amount = Math.floor(eosAsset.amount / (10 ** eosAsset.symbol.precision));
	return formatNumbers(amount);
}

export function formatThousandsOfNumbers(value: number): string
{
	if (value < 1_000)
		return formatNumbers(value);

	value = Math.floor(value / 1000);
	return formatNumbers(value) + " K";
}

export const formatBalance = (balance: number, precision: number, code?: string) => {
	const fraction = 10 ** precision;
	const amount = formatNumbers(balance / fraction);

	return code ? `${amount} ${code}` : `${amount}`;
};
